import React from 'react';
import { List } from 'antd';
import { Link } from 'react-router-dom';

import { Paper as PaperIcon } from 'src/components/Icons';

import { FavoriteType } from '../constants';
import useFavorites from '../useFavorites';
import ListItem from '../ListItem';
import { getPaperLink } from '../utils';

const Paper: React.FC = () => {
  const { entities, loading } = useFavorites(FavoriteType.papers);

  return (
    <List
      dataSource={entities}
      loading={loading}
      renderItem={(item) => {
        const href = getPaperLink(item);
        return (
          <ListItem
            key={item.id}
            as={Link}
            to={href}
            icon={<PaperIcon color="#c1e0ff" />}
            title={item.name}
            content={item.content}
          />
        );
      }}
    />
  );
};

export default Paper;
